import { JobPositionCreateOrUpdateDto, JobPositionDto } from 'types/jobPositions';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APIJobPositionsSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['JobPositions'] }).injectEndpoints({
    endpoints: (builder) => ({
        getJobPositionById: builder.query<JobPositionDto, string>({
            query: (id) => `/v1/job-positions/${id}`,
            keepUnusedDataFor: 0,
        }),
        getJobPositionsList: builder.query<JobPositionDto[], void>({
            query: () => '/v1/job-positions',
            providesTags: ['JobPositions'],
        }),
        getJobPositionsWithFilters: accumulatedQueryWithFilters<JobPositionDto>(builder, '/v1/job-positions', {
            providesTags: ['JobPositions'],
        }),
        addJobPosition: builder.mutation<JobPositionDto, JobPositionCreateOrUpdateDto>({
            query: ({ ...body }) => ({
                url: `/v1/job-positions`,
                method: 'POST',
                body,
            }),
            // Invalidate the getJobPositionsList query after a job position is added
            invalidatesTags: ['JobPositions'],
        }),
        updateJobJobPosition: builder.mutation<JobPositionDto, JobPositionCreateOrUpdateDto & { id: number }>({
            query: ({ id, ...body }) => ({
                url: `/v1/job-positions/${id}`,
                method: 'PUT',
                body,
            }),
            // Invalidate the getJobPositionsList query after a job position is added
            invalidatesTags: ['JobPositions'],
        }),
        deleteJobPosition: builder.mutation<boolean, { id: string }>({
            query: ({ id }) => ({
                url: `/v1/job-positions/${id}`,
                method: 'DELETE',
            }),
            // Invalidate the getJobPositionsList query after a job position is added
            invalidatesTags: ['JobPositions'],
        }),
    }),
    overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetJobPositionByIdQuery,
    useGetJobPositionsListQuery, // corrected here
    useLazyGetJobPositionsWithFiltersQuery, // corrected here
    useAddJobPositionMutation,
    useUpdateJobJobPositionMutation, // corrected here
    useDeleteJobPositionMutation,
} = APIJobPositionsSlice;
